export default __webpack_public_path__ + "3cac52cd5e00f4ae38f9d78999ce11aa.png";